/**
 * schemas/master-data.ts — บริษัท, ลูกค้า, ผู้ขาย, สินค้า, หมวดหมู่ค่าใช้จ่าย
 */
import { z } from 'zod';
import { branchCode, money, optionalText, paginationQuery, requiredText, taxId, } from './common.js';
// ==================== บริษัท (ผู้ออกเอกสาร) ====================
export const companyInputSchema = z.object({
    nameTh: requiredText('ชื่อบริษัท (ไทย)', 200),
    nameEn: optionalText(200),
    taxId,
    branch: branchCode,
    address: optionalText(500),
    phone: optionalText(100),
    email: optionalText(200),
    website: optionalText(200),
    /** บริษัทจด VAT หรือไม่ — ถ้าไม่จด เอกสารจะไม่คิด VAT เลย */
    vatEnabled: z.boolean().default(true),
});
/** อัปโหลดโลโก้ — เก็บเป็น data URI ใน DB เหมือนระบบเดิม เพื่อไม่ผูกกับ filesystem */
export const MAX_LOGO_BYTES = 2 * 1024 * 1024;
export const ALLOWED_LOGO_TYPES = ['image/png', 'image/jpeg', 'image/webp'];
// ==================== ลูกค้า / ผู้ขาย ====================
const partyBase = {
    name: requiredText('ชื่อ', 200),
    taxId,
    branch: branchCode,
    address: optionalText(500),
    phone: optionalText(100),
    email: optionalText(200),
    notes: optionalText(1000),
};
export const customerInputSchema = z.object(partyBase);
export const supplierInputSchema = z.object(partyBase);
export const partyListQuery = paginationQuery.extend({
    search: optionalText(200),
});
// ==================== สินค้า / บริการ ====================
export const productInputSchema = z.object({
    code: optionalText(50),
    name: requiredText('ชื่อสินค้า/บริการ', 200),
    description: optionalText(1000),
    price: money.default(0),
    unit: optionalText(50),
});
export const productListQuery = paginationQuery.extend({
    search: optionalText(200),
});
// ==================== หมวดหมู่ค่าใช้จ่าย ====================
export const expenseCategoryInputSchema = z.object({
    name: requiredText('ชื่อหมวดหมู่', 100),
});
//# sourceMappingURL=master-data.js.map